export default {
    book: 'Book {product}',
    age_limit: "Over {age}'s Only",
    upgrade_product: 'Upgrade product',
    choose_product: 'Choose {product}',
    days: '{count} day | {count} days',
    login_register: 'Login/Register',
    keyless_benefits: {
        label: 'Straight to car {0}',
        highlight: 'rental service™',
        list: {
            cant_lose_the_key: 'Full Insurance',
            zero_excess: 'Zero Excess',
            phone_as_a_key: 'Phone as a Key',
            straight_to_car: 'No waiting',
            no_queues: 'No queues',
            online_id_check: 'Online ID Check',
            self_checkout: 'Self Check-out',
        },
    },
};
